// extracted by mini-css-extract-plugin
export default {"createProjectButton":"CreateProjectButtonFixed_createProjectButton__1PSth"};